var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-bar"},[_c('div',{staticClass:"charts-box"},[_c('div',{staticClass:"myChart-Course-box",attrs:{"id":("myChart-Course-" + _vm.projectID)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }